<template>
  <o-tooltip :label="value" multiline>
    <div @click="handleClick" class="name-column is-link truncate" :style="{ '--name-column-max-width': `${maxWidth}px` }">
        {{value}}
    </div>
  </o-tooltip>
</template>

<script setup lang="ts">

  import {toRefs} from "vue";

  const props = withDefaults(defineProps<{
    row: any,
    value: string,
    maxWidth?: number,
  }>(), {
    maxWidth: 200,
  });
  const {
    row,
    value,
    maxWidth,
  } = toRefs(props);

  const emit = defineEmits<{
    'click': [any],
  }>();

  function handleClick() {
    emit('click', row.value);
  }

</script>

<style scoped lang="scss">
    .name-column {
      max-width: var(--name-column-max-width);
    }
</style>
